import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocalLogic } from "@local-logic/elements-react";
import useDebounce from "~/hooks/useDebounce";
import { useStateManagerContext } from "~/context/stateManager";
import { scoresResponse, scoresKeys } from "~/features/scores";
import { LocalContentProps } from "../types";

export function useScores(include?: Partial<scoresResponse>["include"]) {
  const { client } = useLocalLogic();
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const debouncedOptions = useDebounce(sdkState.options, 250);

  const location = useMemo(() => {
    const hasMarker = !!debouncedOptions?.marker;

    if (hasMarker) {
      return debouncedOptions.marker;
    }

    return {
      lat: debouncedOptions?.lat,
      lng: debouncedOptions?.lng,
    };
  }, [debouncedOptions]);

  const options: scoresResponse = {
    ...location,
    geographyLevels: ["20", "30"],
    locationScoresRounding: false,
    include,
  };

  return useQuery(
    scoresKeys.list(options),
    async () => client.getScores(options as unknown as scoresResponse),
    {
      enabled: !!options,
    }
  );
}
